(() => {
  function initialize(root) {
    root.querySelectorAll('[data-mbm-hat-picker]').forEach((picker) => {
      if (picker.dataset.initialized) return;
      picker.dataset.initialized = 'true';
      const form = document.getElementById(picker.dataset.formId);
      const gallery = picker.closest('.product')?.querySelector('[data-mbm-hat-gallery]');
      if (!form) return;
      const variants = JSON.parse(picker.querySelector('.mbm-hat-variants').textContent);
      const optionNames = JSON.parse(picker.querySelector('.mbm-hat-option-names').textContent).map((x) => x.toLowerCase());
      const variantInput = form.querySelector('input[name="id"]');
      const submit = form.querySelector('button[name="add"]');
      const submitText = submit?.querySelector('span');
      const logoInput = picker.querySelector('[data-hat-logo]');
      const inkInput = picker.querySelector('[data-hat-logo-color]');
      const message = picker.querySelector('[data-hat-message]');
      const requiresSize = picker.dataset.requiresSize !== 'false';
      const normalize = (value) => String(value || '').toLowerCase().replace(/\s*\/\s*/g, '/').replace(/\s+/g, ' ').trim();
      const state = { color: picker.querySelector('[data-hat-colors] button[aria-pressed="true"]')?.dataset.value, logo: '', ink: '', size: '' };
      function pickOption(name, value) {
        const buttons = picker.querySelectorAll(`[data-hat-${name}] button`);
        buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.value === value)));
      }
      function selectVariant() {
        if (!(state.color && state.logo && state.ink && (!requiresSize || state.size))) return null;
        return variants.find((variant) => optionNames.every((optionName, i) => {
          const value = String(variant.options[i] || '');
          if (/colou?r/.test(optionName)) return normalize(value) === normalize(state.color) || (state.color === 'White' && normalize(value) === 'new white');
          if (/size/i.test(optionName)) return !requiresSize || (state.size === 'S/M' ? /small|s\s*\/\s*m/i.test(value) : /large|l\s*\/\s*xl/i.test(value));
          if (/option/i.test(optionName)) return /logo/i.test(value) && !/back|additional|number/i.test(value);
          return true;
        }));
      }
      function refresh() {
        const complete = Boolean(state.color && state.logo && state.ink && (!requiresSize || state.size));
        const variant = selectVariant();
        const available = Boolean(variant?.available);
        variantInput.disabled = !available;
        variantInput.value = available ? variant.id : '';
        logoInput.disabled = !complete;
        inkInput.disabled = !complete;
        logoInput.value = state.logo;
        inkInput.value = state.ink;
        if (submit) submit.disabled = !available;
        if (submitText) submitText.textContent = complete && !available ? 'Unavailable' : 'Add to cart';
        message.textContent = !complete
          ? (requiresSize ? 'Choose a logo, logo color, and size.' : 'Choose a logo and logo color.')
          : !available
            ? (requiresSize ? 'This color and size is unavailable.' : 'This hat color is unavailable.')
            : `Selected: ${state.color} · ${state.logo} · ${state.ink}${requiresSize ? ' · ' + state.size : ''}`;
      }
      function showPhoto(color) {
        gallery?.querySelectorAll('[data-hat-photo]').forEach((img) => { img.hidden = img.dataset.hatPhoto !== color; });
        gallery?.querySelectorAll('[data-hat-thumb]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.hatThumb === color)));
      }
      picker.querySelectorAll('[data-hat-colors] button').forEach((button) => button.addEventListener('click', () => {
        state.color = button.dataset.value;
        pickOption('colors', state.color);
        showPhoto(state.color);
        refresh();
      }));
      picker.querySelectorAll('.mbm-hat-design').forEach((button) => button.addEventListener('click', () => {
        state.logo = button.dataset.value;
        picker.querySelectorAll('.mbm-hat-design').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        refresh();
      }));
      picker.querySelectorAll('[data-hat-logo-colors] button').forEach((button) => button.addEventListener('click', () => {
        state.ink = button.dataset.value;
        pickOption('logo-colors', state.ink);
        refresh();
      }));
      picker.querySelectorAll('[data-hat-sizes] button').forEach((button) => button.addEventListener('click', () => {
        state.size = button.dataset.value;
        pickOption('sizes', state.size);
        refresh();
      }));
      gallery?.querySelectorAll('[data-hat-thumb]').forEach((button) => button.addEventListener('click', () => {
        const choice = picker.querySelector(`[data-hat-colors] button[data-value="${button.dataset.hatThumb}"]`);
        choice?.click();
      }));
      form.addEventListener('submit', (event) => {
        if (submit.disabled || variantInput.disabled) {
          event.preventDefault();
          event.stopImmediatePropagation();
          message.focus?.();
        }
      }, true);
      refresh();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
